import { gql } from '@apollo/client';

export const AllGroupsQuery = gql`
    query Groups {
        groups {
            id
            name
            division
            dataset {
                id
                users
            }
            createdBy {
                username
            }
            createdDate
            groupOnlyExpiryPeriod
            groupSettings {
                useDeliveryZoneForAreaMapping
                useDeliveryZoneForAreaGearedMapping
                useDeliveryZoneForAreaGearlessMapping
                useDeliveryZoneForDirectionMapping
                useHyphenSeparatorForLocations
                tankersGroupType
            }
        }
    }
`;

export const UserGroupsQuery = gql`
    query UserGroups($userId: Int!) {
        userGroups(userId: $userId) {
            id
            name
            datasetName
            groupUser {
                fullName
                canWrite
                createdBy {
                    username
                }
                createdDate
            }
        }
    }
`;
